import React, { FC, useCallback } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { useScreenDetect } from 'src/hooks/useScreenDetect';
import { Button } from 'src/ui/common/atoms/button';
import { Typography } from 'src/ui/common/atoms/typography';
import { ILandingSection } from './landing-section.types';
import { StyledChildrenWrapper, StyledSectionTitle, StyledVisible } from './landing-section.styles';

export const LandingSection: FC<ILandingSection> = ({ title, seeMoreLink, children }) => {
    const { t } = useTranslation(['pages']);
    const router = useRouter();
    const screenType = useScreenDetect();
    const locale: { seeMore: string } = {
        seeMore: t('home.seeMore', { ns: 'pages' }),
    };
    const handleSeeMoreClick = useCallback(() => {
        router.push(seeMoreLink!);
    }, [seeMoreLink, router]);

    return (
        <>
            <StyledSectionTitle
                alignItems={screenType.xs ? 'flex-start' : 'center'}
                justifyContent='space-between' flexDirection={screenType.xs ? 'column' : 'row'}
            >
                <Typography
                    tag='div'
                    overflowLines={1}
                    variant='title'
                    color='text'
                    size={screenType.xs ? 'base' : 'md'}
                >
                    {title}
                </Typography>
                <StyledVisible view='mobile'>
                    <StyledChildrenWrapper>
                        {children}
                    </StyledChildrenWrapper>
                </StyledVisible>
                {seeMoreLink && (
                    <Button
                        variant='outline'
                        stretch={screenType.xs}
                        onClick={handleSeeMoreClick}
                    >
                        {locale.seeMore}
                    </Button>
                )}
            </StyledSectionTitle>
            <StyledVisible view={['laptop', 'desktop']}>
                {children}
            </StyledVisible>
        </>
    );
};
